// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1Vg71","title":"InfoRow_title__2O7Xg"};